<template>
<div class="chapter">
<div class="inner_page">
<p class="western2" id="calibre_pb_4"> <br class="calibre1"/></p>
<p class="western3"> <br class="calibre1"/></p>
<p class="c7"><span class="c4">For Heather, always.</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// tmp_403fa671f87995d2e5aedda9ecddad25_61bGyM.ch.fixed.fc.tidied.stylehacked.xfixed_split_005.vue?31f173fe